/* vq-menu-bestseller.js
   Hält die Punkte und die gewischte Bahn im Mobile-Menü synchron.

   Gewischt wird von CSS (scroll-snap), das Skript macht nur zwei Dinge:
   den aktiven Punkt nachziehen und auf Klick zur passenden Karte springen.
   Bewusst ohne die Dawn-Slider-Komponente: die misst beim Laden Breiten,
   und im geschlossenen Drawer sind die noch 0. */
class VqMenuBestseller extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-vq-mb-track]');
    this.dots = Array.from(this.querySelectorAll('.vq-mb__dot'));

    if (!this.track || this.dots.length < 2) return;

    this.onScroll = this.onScroll.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.index);
        if (Number.isNaN(index)) return;

        // Über die Schrittweite statt über offsetLeft: die Bahn hat einen
        // Innenabstand für den Kartenschatten, den scrollLeft nicht kennt.
        // scrollTo statt scrollIntoView, sonst zieht der Browser das ganze
        // Menü mit, weil die Karte auch senkrecht ins Bild geholt würde.
        this.track.scrollTo({ left: index * this.step, behavior: 'smooth' });
      });
    });
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    // Während des Wischens feuert scroll sehr oft – ein Frame reicht.
    if (this.frame) return;

    this.frame = requestAnimationFrame(() => {
      this.frame = null;

      const step = this.step;
      if (!step) return;

      const index = Math.min(this.dots.length - 1, Math.round(this.track.scrollLeft / step));

      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('vq-mb__dot--active', active);

        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    });
  }

  /* Breite einer Karte samt Abstand – also der Weg von Slide zu Slide. */
  get step() {
    const slide = this.track.firstElementChild;
    if (!slide) return 0;

    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return slide.offsetWidth + gap;
  }
}

if (!customElements.get('vq-menu-bestseller')) {
  customElements.define('vq-menu-bestseller', VqMenuBestseller);
}
